export default __webpack_public_path__ + "static/media/cleaning_vertical_responsive.14cebfb9.png";